"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNodeSelected = exports.isNodeIndeterminate = exports.isNodeUnChecked = exports.isNodeChecked = exports.hasChildren = exports.getDisabledState = exports.getCheckState = void 0;

var _constants = require("./constants");

/**
 * @function
 * @name isEveryChildChecked
 * Check if every child is checked
 * @param {Object} node
 * @returns {Boolean} returns Checked
 */
var isEveryChildChecked = function isEveryChildChecked(node) {
  return node.children.every(function (child) {
    if (child.children) {
      return isEveryChildChecked(child);
    }

    return child.checked;
  });
};
/**
 * @function
 * @name isSomeChildChecked
 * Check if some children are checked
 * @param {Object} node
 * @returns {Boolean} returns Checked
 */


var isSomeChildChecked = function isSomeChildChecked(node) {
  return node.children.some(function (child) {
    if (child.children) {
      return isSomeChildChecked(child);
    }

    return child.checked;
  });
};
/**
 * @function
 * @name getCheckState
 * Get the checked state by nodes
 * @param {Object} node
 * @param {Boolean} noCascade
 * @returns {Number} returns check state [0=>unchecked, 1=>checked, 2=>indeterminate]
 */


var getCheckState = function getCheckState(_ref) {
  var _ref$node = _ref.node,
      node = _ref$node === void 0 ? {} : _ref$node,
      noCascade = _ref.noCascade;

  if (!node.children || noCascade) {
    return node.checked ? _constants.enumCheckboxState.CHECKED : _constants.enumCheckboxState.UNCHECKED;
  }

  if (isEveryChildChecked(node)) {
    return _constants.enumCheckboxState.CHECKED;
  }

  if (isSomeChildChecked(node)) {
    return _constants.enumCheckboxState.INDETERMINATE;
  }

  return _constants.enumCheckboxState.UNCHECKED;
};
/**
 * @function
 * @name getDisabledState
 * Get the disabled state by nodes
 * @param {Object} node
 * @param {Object} parent
 * @param {Boolean} disabledProp
 * @param {Boolean} noCascade
 * @returns {Boolean} returns disabled state
 */


exports.getCheckState = getCheckState;

var getDisabledState = function getDisabledState(_ref2) {
  var _ref2$node = _ref2.node,
      node = _ref2$node === void 0 ? {} : _ref2$node,
      parent = _ref2.parent,
      disabledProp = _ref2.disabledProp,
      noCascade = _ref2.noCascade;

  if (disabledProp) {
    return true;
  }

  if (!noCascade && parent.disabled) {
    return true;
  }

  return Boolean(node.disabled);
};
/**
 * @function
 * @name hasChildren
 * Check if has children
 * @param {Object} rawChildren
 * @returns {Boolean} returns boolean if there are children
 */


exports.getDisabledState = getDisabledState;

var hasChildren = function hasChildren(rawChildren) {
  return rawChildren !== null;
};
/**
 * @function
 * @name isNodeChecked
 * Check if the node is checked
 * @param {Number} checked
 * @returns {Boolean} returns boolean if checked or not
 */


exports.hasChildren = hasChildren;

var isNodeChecked = function isNodeChecked(checked) {
  return checked === _constants.enumCheckboxState.CHECKED;
};
/**
 * @function
 * @name isNodeUnChecked
 * Check if the node is unchecked
 * @param {Number} checked
 * @returns {Boolean} returns boolean if unchecked or not
 */


exports.isNodeChecked = isNodeChecked;

var isNodeUnChecked = function isNodeUnChecked(checked) {
  return checked === _constants.enumCheckboxState.UNCHECKED;
};
/**
 * @function
 * @name isNodeIndeterminate
 * Check if the node is indeterminate
 * @param {Number} checked
 * @returns {Boolean} returns boolean if indeterminate or not
 */


exports.isNodeUnChecked = isNodeUnChecked;

var isNodeIndeterminate = function isNodeIndeterminate(checked) {
  return checked === _constants.enumCheckboxState.INDETERMINATE;
};
/**
 * @function
 * @name isNodeSelected
 * Check if the node is selected
 * @param {Number} checked
 * @returns {Boolean} returns boolean if indeterminate or not
 */


exports.isNodeIndeterminate = isNodeIndeterminate;

var isNodeSelected = function isNodeSelected(_ref3) {
  var value = _ref3.value,
      selectedValue = _ref3.selectedValue;
  return value === selectedValue;
};

exports.isNodeSelected = isNodeSelected;
//# sourceMappingURL=utils.js.map